<div class="ui fluid pointing vertical menu secondary" id="sidebar">
  <div
    tamsyMargin
    marginB="2"
    class="item"
    routerLink="/admin/dashboard"
    routerLinkActive="active"
  >
    <div class="middle aligned content">
      <div class="header">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.773 9.23519L11.6327 1.04132C11.6223 1.03078 11.6115 1.02054 11.6005 1.01062C10.7116 0.212535 9.36843 0.209683 8.47617 1.00402C8.46507 1.0139 8.45429 1.0241 8.44378 1.03457L0.229371 9.23281C-0.0760201 9.53765 -0.0765279 10.0323 0.228277 10.3377C0.533121 10.6431 1.02777 10.6436 1.33312 10.3388L1.95312 9.72V16.4655C1.95312 18.1886 3.355 19.5905 5.07812 19.5905H7.89062C8.3221 19.5905 8.67187 19.2407 8.67187 18.8092V12.442H11.4062V18.8092C11.4062 19.2407 11.756 19.5905 12.1875 19.5905H14.9219C16.645 19.5905 18.0469 18.1886 18.0469 16.4655C18.0469 16.034 17.6971 15.6842 17.2656 15.6842C16.8341 15.6842 16.4844 16.034 16.4844 16.4655C16.4844 17.327 15.7834 18.028 14.9219 18.028H12.9687V11.6608C12.9687 11.2293 12.619 10.8795 12.1875 10.8795H7.89062C7.45914 10.8795 7.10937 11.2293 7.10937 11.6608V18.028H5.07812C4.21656 18.028 3.51562 17.327 3.51562 16.4655V8.18422C3.51562 8.1764 3.5155 8.16863 3.51527 8.16089L9.52914 2.1589C9.82183 1.91035 10.2511 1.91128 10.5427 2.16105L16.4844 8.14191V12.5592C16.4844 12.9907 16.8341 13.3405 17.2656 13.3405C17.6971 13.3405 18.0469 12.9907 18.0469 12.5592V9.71468L18.6645 10.3364C18.8172 10.4902 19.0179 10.5671 19.2187 10.5671C19.4178 10.5671 19.617 10.4914 19.7694 10.34C20.0755 10.0359 20.0771 9.54129 19.773 9.23519Z"
            fill="white"
          />
        </svg>

        Home
      </div>
    </div>
  </div>
  <div
    *isPermitted="{ id: 'DEPARTMENTS', action: 'read' }"
    tamsyMargin
    marginB="2"
    routerLink="admin/department"
    routerLinkActive="active"
    class="item"
  >
    <div class="middle aligned content">
      <div class="header">
        <svg
          width="18"
          height="16"
          viewBox="0 0 18 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.3333 5.08325C17.3333 4.15825 16.5917 3.41659 15.6667 3.41659H12.3333V1.74992C12.3333 0.824919 11.5917 0.083252 10.6667 0.083252H7.33332C6.40832 0.083252 5.66666 0.824919 5.66666 1.74992V3.41659H2.33332C1.40832 3.41659 0.67499 4.15825 0.67499 5.08325L0.666656 14.2499C0.666656 15.1749 1.40832 15.9166 2.33332 15.9166H15.6667C16.5917 15.9166 17.3333 15.1749 17.3333 14.2499V5.08325ZM10.6667 3.41659V1.74992H7.33332V3.41659H10.6667ZM2.33332 5.08325V14.2499H15.6667V5.08325H2.33332Z"
            fill="white"
          />
        </svg>
        Departments & Units
      </div>
    </div>
  </div>
  <div
    *isPermitted="{ id: 'MY_TASKS', action: 'read' }"
    tamsyMargin
    marginB="2"
    routerLink="admin/tasks"
    routerLinkActive="active"
    class="item"
  >
    <div class="middle aligned content">
      <div class="header">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.144 13.7891C17.5755 13.7891 17.9253 13.4393 17.9253 13.0078V5.07812C17.9253 3.35495 16.5234 1.95312 14.8003 1.95312H12.3062C12.1196 0.8461 11.1548 0 9.99557 0C8.83652 0 7.8717 0.8461 7.68509 1.95312H5.19531C3.47214 1.95312 2.07031 3.35495 2.07031 5.07812V16.875C2.07031 18.5982 3.47214 20 5.19531 20H14.8004C16.5234 20 17.9254 18.5982 17.9254 16.875C17.9254 16.4435 17.5755 16.0938 17.1442 16.0938C16.7126 16.0938 16.3629 16.4435 16.3629 16.875C16.3629 17.7365 15.6619 18.4375 14.8004 18.4375H5.19531C4.3338 18.4375 3.63281 17.7365 3.63281 16.875V5.07812C3.63281 4.21661 4.3338 3.51562 5.19531 3.51562H7.94479C8.34473 4.23706 9.11407 4.72656 9.99573 4.72656C10.8774 4.72656 11.6466 4.23706 12.0467 3.51562H14.8004C15.6619 3.51562 16.3629 4.21661 16.3629 5.07812V13.0078C16.3628 13.4393 16.7126 13.7891 17.144 13.7891ZM9.99557 3.16406C9.56482 3.16406 9.21432 2.81357 9.21432 2.38281V2.34375C9.21432 1.91299 9.56482 1.5625 9.99557 1.5625C10.4263 1.5625 10.7768 1.91299 10.7768 2.34375V2.38281C10.7768 2.81357 10.4265 3.16406 9.99557 3.16406ZM7.06589 9.50333L6.44653 10.1227C6.29395 10.2753 6.09406 10.3516 5.89401 10.3516C5.69412 10.3516 5.49423 10.2753 5.34164 10.1227C5.03647 9.81766 5.03647 9.32297 5.34164 9.01779L5.961 8.39844L5.34164 7.77908C5.03662 7.47391 5.03662 6.97922 5.34164 6.67419C5.64682 6.36917 6.14151 6.36917 6.44653 6.67419L7.06589 7.29355L7.68539 6.67419C7.99042 6.36917 8.48511 6.36917 8.79028 6.67419C9.09531 6.97922 9.09531 7.47391 8.79028 7.77908L8.17078 8.39844L8.79028 9.01779C9.09531 9.32297 9.09531 9.81766 8.79028 10.1227C8.6377 10.2753 8.43781 10.3516 8.23776 10.3516C8.03787 10.3516 7.83783 10.2753 7.68524 10.1227L7.06589 9.50333ZM14.6497 14.4978L14.0302 15.1172L14.6497 15.7365C14.9547 16.0417 14.9547 16.5364 14.6497 16.8414C14.4971 16.994 14.2972 17.0703 14.0971 17.0703C13.8972 17.0703 13.6972 16.994 13.5446 16.8414L12.9253 16.2221L12.3059 16.8414C12.1533 16.994 11.9534 17.0703 11.7534 17.0703C11.5535 17.0703 11.3535 16.994 11.2009 16.8414C10.8958 16.5364 10.8958 16.0417 11.2009 15.7365L11.8204 15.1172L11.201 14.4978C10.896 14.1927 10.896 13.698 11.201 13.3929C11.5062 13.0879 12.0009 13.0879 12.3059 13.3929L12.9253 14.0123L13.5448 13.3929C13.8498 13.0879 14.3445 13.0879 14.6497 13.3929C14.9547 13.698 14.9547 14.1927 14.6497 14.4978ZM5.93307 15.4688C6.36459 15.4688 6.71432 15.8185 6.71432 16.25C6.71432 16.6815 6.36459 17.0312 5.93307 17.0312C5.50171 17.0312 5.15182 16.6815 5.15182 16.25C5.15182 15.8185 5.50171 15.4688 5.93307 15.4688ZM14.8784 9.96094C14.8784 10.3925 14.5287 10.7422 14.0971 10.7422C13.6658 10.7422 13.3159 10.3925 13.3159 9.96094V9.17511L8.11646 14.9747C7.96204 15.1468 7.74872 15.2344 7.53448 15.2344C7.34879 15.2344 7.16232 15.1686 7.01324 15.0348C6.69189 14.7469 6.66504 14.2528 6.95297 13.9316L12.2641 8.00781H11.3629C10.9314 8.00781 10.5817 7.65808 10.5817 7.22656C10.5817 6.79504 10.9314 6.44531 11.3629 6.44531H13.316C14.1776 6.44531 14.8785 7.1463 14.8785 8.00781V9.96094H14.8784Z"
            fill="white"
          />
        </svg>
        <div style="display: flex; align-items: center">
          <div>My Tasks</div>
          <div class="tag">{{ totalItems }}</div>
        </div>
      </div>
    </div>
  </div>
  <div
    *isPermitted="{ id: 'USERS', action: 'read' }"
    tamsyMargin
    marginB="2"
    routerLink="admin/user"
    routerLinkActive="active"
    class="item"
  >
    <div class="middle aligned content">
      <div class="header">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.3333 5.83333C13.3333 7.67428 11.8409 9.16667 9.99999 9.16667C8.15904 9.16667 6.66666 7.67428 6.66666 5.83333C6.66666 3.99238 8.15904 2.5 9.99999 2.5C11.8409 2.5 13.3333 3.99238 13.3333 5.83333Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.99999 11.6667C6.77833 11.6667 4.16666 14.2783 4.16666 17.5H15.8333C15.8333 14.2783 13.2217 11.6667 9.99999 11.6667Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Users
      </div>
    </div>
  </div>
  <div
    tamsyMargin
    marginB="2"
    *isPermitted="{ id: 'AOL_MANAGEMENT', action: 'read' }"
    routerLink="admin/aol"
    routerLinkActive="active"
    class="item"
  >
    <div class="middle aligned content">
      <div class="header">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.50008 14.1667V12.5M10.0001 14.1667V10.8333M12.5001 14.1667V9.16667M14.1667 17.5H5.83341C4.91294 17.5 4.16675 16.7538 4.16675 15.8333V4.16667C4.16675 3.24619 4.91294 2.5 5.83341 2.5H10.4882C10.7093 2.5 10.9212 2.5878 11.0775 2.74408L15.5893 7.25592C15.7456 7.4122 15.8334 7.62416 15.8334 7.84518V15.8333C15.8334 16.7538 15.0872 17.5 14.1667 17.5Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        AOL
      </div>
    </div>
  </div>
  <div
    *isPermitted="{ id: 'ROLES', action: 'read' }"
    tamsyMargin
    marginB="2"
    routerLink="admin/role"
    routerLinkActive="active"
    class="item"
  >
    <div class="middle aligned content">
      <div class="header">
        <svg
          width="20"
          height="20"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M42.375 36.75C41.4529 36.75 40.5824 36.9745 39.8137 37.3696L35.6199 33.1758C37.6179 30.6508 38.8125 27.4625 38.8125 24C38.8125 20.5906 37.6542 17.447 35.7107 14.9407L39.9514 10.7003C40.6857 11.0522 41.5078 11.25 42.375 11.25C43.4106 11.25 44.25 10.4106 44.25 9.375C44.25 8.33936 43.4106 7.5 42.375 7.5C41.3412 7.5 40.5 6.65881 40.5 5.625C40.5 4.59119 41.3412 3.75 42.375 3.75C43.4088 3.75 44.25 4.59119 44.25 5.625C44.25 6.66064 45.0894 7.5 46.125 7.5C47.1606 7.5 48 6.66064 48 5.625C48 2.52319 45.4768 0 42.375 0C39.2732 0 36.75 2.52319 36.75 5.625C36.75 6.49219 36.9478 7.31433 37.2997 8.04858L33.0593 12.2893C30.553 10.3462 27.4094 9.1875 24 9.1875C20.5375 9.1875 17.3489 10.3821 14.8242 12.3801L10.6304 8.18628C11.0255 7.4176 11.25 6.54749 11.25 5.625C11.25 2.52319 8.72681 0 5.625 0C2.52319 0 0 2.52319 0 5.625C0 8.72681 2.52319 11.25 5.625 11.25C6.43652 11.25 7.20813 11.0757 7.90576 10.7651L12.1989 15.0582C10.3103 17.5452 9.1875 20.6437 9.1875 24C9.1875 27.4094 10.3458 30.553 12.2893 33.059L8.04858 37.2997C7.31433 36.9478 6.49219 36.75 5.625 36.75C2.52319 36.75 0 39.2732 0 42.375C0 45.4768 2.52319 48 5.625 48C6.66064 48 7.5 47.1606 7.5 46.125C7.5 45.0894 6.66064 44.25 5.625 44.25C4.59119 44.25 3.75 43.4088 3.75 42.375C3.75 41.3412 4.59119 40.5 5.625 40.5C6.65881 40.5 7.5 41.3412 7.5 42.375C7.5 43.4106 8.33936 44.25 9.375 44.25C10.4106 44.25 11.25 43.4106 11.25 42.375C11.25 41.5078 11.0522 40.6857 10.7003 39.9514L14.941 35.7107C17.447 37.6538 20.5906 38.8125 24 38.8125C27.3563 38.8125 30.4552 37.6897 32.9418 35.8011L37.2349 40.0942C36.9243 40.7919 36.75 41.5635 36.75 42.375C36.75 45.4768 39.2732 48 42.375 48C43.4106 48 44.25 47.1606 44.25 46.125C44.25 45.0894 43.4106 44.25 42.375 44.25C41.3412 44.25 40.5 43.4088 40.5 42.375C40.5 41.3412 41.3412 40.5 42.375 40.5C43.4088 40.5 44.25 41.3412 44.25 42.375C44.25 43.4106 45.0894 44.25 46.125 44.25C47.1606 44.25 48 43.4106 48 42.375C48 39.2732 45.4768 36.75 42.375 36.75ZM35.0625 24C35.0625 26.6345 34.1364 29.0566 32.5931 30.9584C31.8453 29.1141 30.5208 27.5632 28.8435 26.5309C29.684 25.4744 30.1875 24.1392 30.1875 22.6875C30.1875 19.2755 27.412 16.5 24 16.5C20.588 16.5 17.8125 19.2755 17.8125 22.6875C17.8125 24.1392 18.316 25.4744 19.1565 26.5309C17.4792 27.5632 16.1547 29.1141 15.4069 30.9584C13.8636 29.0566 12.9375 26.6345 12.9375 24C12.9375 17.9 17.9 12.9375 24 12.9375C30.1 12.9375 35.0625 17.9 35.0625 24ZM24 25.125C22.656 25.125 21.5625 24.0315 21.5625 22.6875C21.5625 21.3435 22.656 20.25 24 20.25C25.344 20.25 26.4375 21.3435 26.4375 22.6875C26.4375 24.0315 25.344 25.125 24 25.125ZM3.75 5.625C3.75 4.59119 4.59119 3.75 5.625 3.75C6.65881 3.75 7.5 4.59119 7.5 5.625C7.5 6.65881 6.65881 7.5 5.625 7.5C4.59119 7.5 3.75 6.65881 3.75 5.625ZM18.542 33.6193C18.9349 30.9595 21.2325 28.9113 24 28.9113C26.7675 28.9113 29.0651 30.9595 29.458 33.6193C27.8463 34.5374 25.9834 35.0625 24 35.0625C22.0166 35.0625 20.1537 34.5374 18.542 33.6193Z"
            fill="#3F4395"
          />
          <!-- <path d="M13.3333 5.83333C13.3333 7.67428 11.8409 9.16667 9.99999 9.16667C8.15904 9.16667 6.66666 7.67428 6.66666 5.83333C6.66666 3.99238 8.15904 2.5 9.99999 2.5C11.8409 2.5 13.3333 3.99238 13.3333 5.83333Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.99999 11.6667C6.77833 11.6667 4.16666 14.2783 4.16666 17.5H15.8333C15.8333 14.2783 13.2217 11.6667 9.99999 11.6667Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> -->
        </svg>
        Roles
      </div>
    </div>
  </div>
  <div
    *isPermitted="{ id: 'ALL_COMPANIES_MANAGEMENT', action: 'read' }"
    tamsyMargin
    marginB="2"
    routerLink="admin/company"
    routerLinkActive="active"
    class="item"
  >
    <div class="middle aligned content">
      <div class="header">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8333 17.5V4.16667C15.8333 3.24619 15.0871 2.5 14.1667 2.5H5.83333C4.91286 2.5 4.16667 3.24619 4.16667 4.16667V17.5M15.8333 17.5L17.5 17.5M15.8333 17.5H11.6667M4.16667 17.5L2.5 17.5M4.16667 17.5H8.33333M7.5 5.83331H8.33333M7.5 9.16665H8.33333M11.6667 5.83331H12.5M11.6667 9.16665H12.5M8.33333 17.5V13.3333C8.33333 12.8731 8.70643 12.5 9.16667 12.5H10.8333C11.2936 12.5 11.6667 12.8731 11.6667 13.3333V17.5M8.33333 17.5H11.6667"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        All Companies
      </div>
    </div>
  </div>
  <div
    *isPermitted="{ id: 'REGISTERED_COMPANIES_MANAGEMENT', action: 'read' }"
    tamsyMargin
    marginB="2"
    routerLink="admin/companies"
    routerLinkActive="active"
    class="item"
  >
    <div class="middle aligned content">
      <div class="header">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 0.833252L2.5 4.16658V9.16658C2.5 13.7916 5.7 18.1166 10 19.1666C14.3 18.1166 17.5 13.7916 17.5 9.16658V4.16658L10 0.833252ZM15.8333 9.1666C15.8333 12.9333 13.35 16.4083 10 17.4416C6.65 16.4083 4.16667 12.9333 4.16667 9.1666V5.24993L10 2.65826L15.8333 5.24993V9.1666ZM5 10.8333L6.175 9.65826L8.33333 11.8083L13.825 6.31659L15 7.49993L8.33333 14.1666L5 10.8333Z"
            fill="white"
          />
        </svg>
        Registered Companies
      </div>
    </div>
  </div>
  <div
    *isPermitted="{ id: 'REGISTERED_COMPANIES_MANAGEMENT', action: 'read' }"
    tamsyMargin
    marginB="2"
    routerLink="admin/entities"
    routerLinkActive="active"
    class="item"
  >
    <div class="middle aligned content">
      <div class="header">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.69671 4.69671C4.00027 5.39316 3.44782 6.21996 3.07091 7.1299C2.69399 8.03985 2.5 9.01513 2.5 10C2.5 10.985 2.69399 11.9602 3.07091 12.8702C3.44782 13.7801 4.00027 14.6069 4.69671 15.3034C5.39316 15.9998 6.21996 16.5523 7.1299 16.9292C8.03985 17.3061 9.01513 17.5001 10 17.5001C10.985 17.5001 11.9602 17.3061 12.8702 16.9292C13.7801 16.5523 14.6069 15.9998 15.3034 15.3034M4.69671 4.69671C5.39316 4.00027 6.21996 3.44782 7.1299 3.07091C8.03985 2.69399 9.01513 2.5 10 2.5C10.985 2.5 11.9602 2.69399 12.8702 3.07091C13.7801 3.44782 14.6069 4.00027 15.3034 4.69671C15.9998 5.39316 16.5523 6.21996 16.9292 7.1299C17.3061 8.03985 17.5001 9.01513 17.5001 10C17.5001 10.985 17.3061 11.9602 16.9292 12.8702C16.5523 13.7801 15.9998 14.6069 15.3034 15.3034M4.69671 4.69671L10 10L15.3034 15.3034"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Restricted Entities
      </div>
    </div>
  </div>
  <!-- <div tamsyMargin marginB="2"  routerLink='admin/data' routerLinkActive='active' class="item">
        <div class="middle aligned content">
            <div class="header">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33334 5.83333V14.1667C3.33334 16.0076 6.31811 17.5 10 17.5C13.6819 17.5 16.6667 16.0076 16.6667 14.1667V5.83333M3.33334 5.83333C3.33334 7.67428 6.31811 9.16667 10 9.16667C13.6819 9.16667 16.6667 7.67428 16.6667 5.83333M3.33334 5.83333C3.33334 3.99238 6.31811 2.5 10 2.5C13.6819 2.5 16.6667 3.99238 16.6667 5.83333M16.6667 10C16.6667 11.8409 13.6819 13.3333 10 13.3333C6.31811 13.3333 3.33334 11.8409 3.33334 10" stroke="white" stroke-width="2"/>
            </svg>
        <i class="database big icon" style="font-size: 15px; "></i>
				Customer Data
            </div>
        </div>
	</div> -->

  <div
    tamsyMargin
    marginB="2"
    *isPermitted="{ id: 'CHAT', action: 'read' }"
    class="item"
    routerLink="admin/new-chat"
    routerLinkActive="active"
  >
    <div class="middle aligned content">
      <div class="header">
        <!-- <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.1667 6.66683H15.8333C16.7538 6.66683 17.5 7.41302 17.5 8.3335V13.3335C17.5 14.254 16.7538 15.0002 15.8333 15.0002H14.1667V18.3335L10.8333 15.0002H7.5C7.03976 15.0002 6.6231 14.8136 6.32149 14.512M6.32149 14.512L9.16667 11.6668H12.5C13.4205 11.6668 14.1667 10.9206 14.1667 10.0002V5.00016C14.1667 4.07969 13.4205 3.3335 12.5 3.3335H4.16667C3.24619 3.3335 2.5 4.07969 2.5 5.00016V10.0002C2.5 10.9206 3.24619 11.6668 4.16667 11.6668H5.83333V15.0002L6.32149 14.512Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg> -->
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.1667 4.66683H14.8333C15.7538 4.66683 16.5 5.41302 16.5 6.3335V11.3335C16.5 12.254 15.7538 13.0002 14.8333 13.0002H13.1667V16.3335L9.83333 13.0002H6.5C6.03976 13.0002 5.6231 12.8136 5.32149 12.512M5.32149 12.512L8.16667 9.66683H11.5C12.4205 9.66683 13.1667 8.92064 13.1667 8.00016V3.00016C13.1667 2.07969 12.4205 1.3335 11.5 1.3335H3.16667C2.24619 1.3335 1.5 2.07969 1.5 3.00016V8.00016C1.5 8.92064 2.24619 9.66683 3.16667 9.66683H4.83333V13.0002L5.32149 12.512Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <!-- <i class="chat icon" style="font-size: 15px; "></i> -->
        <div style="display: flex; align-items: center; gap: 8px">
          Chat
          <svg
            width="17"
            height="20"
            viewBox="0 0 17 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.49121 17.5801C5.9908 18.7095 7.12142 19.5 8.43378 19.5C9.74614 19.5 10.8767 18.7095 11.3764 17.5801H5.49121Z"
              fill="white"
            />
            <path
              d="M16.2269 16.331H0.641005C0.34614 16.331 0.0760482 16.1322 0.0147187 15.8437C-0.0459864 15.5581 0.0841672 15.2763 0.348222 15.1543C0.410883 15.1136 0.882534 14.7838 1.35473 13.786C2.22196 11.9536 2.40399 9.37242 2.40399 7.5297C2.40399 4.20487 5.10895 1.5 8.43373 1.5C11.7507 1.5 14.4506 4.19184 14.4634 7.50576C14.4637 7.51371 14.4639 7.52171 14.4639 7.5297C14.4639 9.37242 14.6459 11.9536 15.5132 13.786C15.9853 14.7838 16.457 15.1137 16.5197 15.1543C16.7837 15.2763 16.9139 15.5581 16.8532 15.8437C16.7918 16.1321 16.5218 16.331 16.2269 16.331ZM16.5267 15.1587H16.5271H16.5267Z"
              fill="white"
            />
            <circle cx="13" cy="4.5" r="4" fill="#FF2C2C" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- <div
    tamsyMargin
    marginB="2"
    *isPermitted="{ id: 'CHAT', action: 'read' }"
    class="item"
    routerLink="admin/ai-chat"
    routerLinkActive="active"
  >
    <div class="middle aligned content">
      <div class="header">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.1667 4.66683H14.8333C15.7538 4.66683 16.5 5.41302 16.5 6.3335V11.3335C16.5 12.254 15.7538 13.0002 14.8333 13.0002H13.1667V16.3335L9.83333 13.0002H6.5C6.03976 13.0002 5.6231 12.8136 5.32149 12.512M5.32149 12.512L8.16667 9.66683H11.5C12.4205 9.66683 13.1667 8.92064 13.1667 8.00016V3.00016C13.1667 2.07969 12.4205 1.3335 11.5 1.3335H3.16667C2.24619 1.3335 1.5 2.07969 1.5 3.00016V8.00016C1.5 8.92064 2.24619 9.66683 3.16667 9.66683H4.83333V13.0002L5.32149 12.512Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <div style="display: flex; align-items: center; gap: 8px">AI Chat</div>
      </div>
    </div>
  </div> -->

  <div
    *isPermitted="{ id: 'AUDIT_TRAIL', action: 'read' }"
    tamsyMargin
    marginB="2"
    class="item"
    routerLink="admin/audit-trail"
    routerLinkActive="active"
  >
    <div class="middle aligned center">
      <div class="header">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.25 12.0834L11.25 17.0834L10.0667 15.9001L13.0583 12.9167H3.75V2.91675H5.41667V11.2501H13.0583L10.0667 8.26675L11.25 7.08342L16.25 12.0834Z"
            fill="white"
          />
        </svg>
        Audit Trail
      </div>
    </div>
  </div>

  <!-- <a tamsyMargin marginB="2" class="item" routerLink='admin/advertisement' routerLinkActive='active' >
        <div class="middle aligned center">
            <div class="header">
               <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M19.2188 11.015C19.6502 11.015 20 10.6652 20 10.2338V2.34447C20 1.58302 19.6283 0.866694 19.0058 0.428218C18.3832 -0.0102198 17.5835 -0.118774 16.8666 0.137671C16.8446 0.145561 16.8229 0.154468 16.8016 0.164311L10.5427 3.06236C9.16481 3.70033 7.69629 4.02834 6.17793 4.03716L3.1225 4.05498C1.40055 4.05638 0 5.45771 0 7.18001V9.21126C0 10.5971 0.915859 11.7901 2.1875 12.1915V17.6248C2.1875 18.2606 2.44891 18.8817 2.90469 19.3288C3.34656 19.7623 3.92273 19.9994 4.53172 19.9994C4.54664 19.9994 4.56168 19.9993 4.57664 19.999C5.19324 19.9872 5.77098 19.7382 6.20344 19.2979C6.63652 18.857 6.875 18.2738 6.875 17.6556V12.3336C8.19363 12.4329 9.49715 12.7819 10.6857 13.3576L16.782 16.3103C16.806 16.322 16.8306 16.3323 16.8557 16.3415C17.5735 16.6024 18.3755 16.4965 19.001 16.0583C19.6265 15.62 20 14.9024 20 14.1386C20 13.7072 19.6502 13.3574 19.2188 13.3574C18.7873 13.3574 18.4375 13.7072 18.4375 14.1386C18.4375 14.397 18.3161 14.6302 18.1045 14.7785C17.902 14.9204 17.6547 14.958 17.4211 14.8837L11.3668 11.9514C9.96719 11.2735 8.42863 10.8693 6.875 10.7673V5.5765C8.37438 5.48377 9.82598 5.11611 11.1992 4.48033L17.4209 1.59951C17.6554 1.52509 17.9035 1.56306 18.1061 1.7058C18.3167 1.85412 18.4375 2.08693 18.4375 2.34455V10.2338C18.4375 10.6652 18.7873 11.015 19.2188 11.015ZM5.3125 17.6556C5.3125 18.0783 4.96902 18.4286 4.54676 18.4367C4.34473 18.4405 4.14961 18.3613 3.99891 18.2134C3.84074 18.0582 3.75 17.8437 3.75 17.6248V11.5492C3.75 11.1379 3.43113 10.797 3.02074 10.7696C2.20305 10.7151 1.5625 10.0306 1.5625 9.21126V7.18001C1.5625 6.31845 2.26344 5.61751 3.125 5.61751H3.12957L5.3125 5.60478V17.6556Z" fill="white"/>
				</svg>
				Advertisement
            </div>
        </div>
	</a>

	<a tamsyMargin marginB="2" class="item" routerLink='admin/award' routerLinkActive='active' >
        <div class="middle aligned center">
            <div class="header">
               <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M18.8911 1.12715C19.0107 0.885 18.9967 0.598242 18.8541 0.368867C18.7116 0.139492 18.4607 0 18.1906 0H13.1366C12.8392 0 12.5677 0.16875 12.4361 0.435352L9.31727 6.75086C8.16551 6.86418 7.09915 7.27297 6.19532 7.90027L3.06555 1.5625H6.37696L7.63141 4.10277C7.82247 4.48965 8.2909 4.64836 8.67782 4.45734C9.06469 4.26629 9.22344 3.79781 9.03239 3.41094L7.56297 0.435352C7.43133 0.16875 7.15977 0 6.86247 0H1.80844C1.53836 0 1.28743 0.139492 1.14485 0.368867C1.00231 0.598242 0.988326 0.885 1.10794 1.12715L4.96598 8.93965C4.97243 8.95273 4.97922 8.96555 4.98629 8.97809C3.95692 10.1482 3.33188 11.6821 3.33188 13.3594C3.33188 17.021 6.31087 20 9.97251 20C11.1939 20 12.3882 19.6654 13.4261 19.0322C13.7945 18.8075 13.9109 18.3268 13.6863 17.9584C13.4615 17.59 12.9808 17.4735 12.6125 17.6982C11.8196 18.1818 10.9067 18.4375 9.97243 18.4375C7.17231 18.4375 4.8943 16.1594 4.8943 13.3593C4.8943 10.5593 7.17231 8.28121 9.97243 8.28121C12.7725 8.28121 15.0506 10.5593 15.0506 13.3593C15.0506 14.0277 14.923 14.6769 14.6714 15.2889C14.5073 15.6879 14.6979 16.1445 15.0969 16.3085C15.496 16.4726 15.9525 16.282 16.1166 15.883C16.4461 15.0816 16.6131 14.2325 16.6131 13.3594C16.6131 11.6996 16.001 10.1801 14.9907 9.01473C15.006 8.99074 15.0201 8.9657 15.033 8.93965L18.8911 1.12715ZM13.7898 7.92836C12.9841 7.36039 12.047 6.96695 11.0339 6.80352L13.6221 1.5625H16.9334L13.7898 7.92836Z" fill="white"/>
				<path d="M10.0124 16.1719C10.4439 16.1719 10.7936 15.8221 10.7936 15.3906V11.4062C10.7936 10.9748 10.4439 10.625 10.0124 10.625H8.6452C8.21372 10.625 7.86395 10.9748 7.86395 11.4062C7.86395 11.8377 8.21372 12.1875 8.6452 12.1875H9.23114V15.3906C9.23114 15.8221 9.5809 16.1719 10.0124 16.1719Z" fill="white"/>
				</svg>
				Awards
            </div>
        </div>
	</a>

	 <a tamsyMargin marginB="2" class="item" routerLink='admin/implementation' routerLinkActive='active' >
        <div class="middle aligned center">
            <div class="header">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M14.8003 20H5.19531C3.47214 20 2.07031 18.5982 2.07031 16.875V3.125C2.07031 1.40182 3.47214 0 5.19531 0H14.8004C16.5234 0 17.9254 1.40182 17.9254 3.125V12.9688C17.9254 13.4003 17.5755 13.75 17.1442 13.75C16.7126 13.75 16.3629 13.4003 16.3629 12.9688V3.125C16.3629 2.26349 15.6619 1.5625 14.8004 1.5625H5.19531C4.3338 1.5625 3.63281 2.26349 3.63281 3.125V16.875C3.63281 17.7365 4.3338 18.4375 5.19531 18.4375H14.8004C15.6619 18.4375 16.3629 17.7365 16.3629 16.875C16.3629 16.4435 16.7126 16.0938 17.1442 16.0938C17.5755 16.0938 17.9254 16.4435 17.9254 16.875C17.9253 18.5982 16.5234 20 14.8003 20ZM9.37271 13.7042C9.93195 13.667 10.4539 13.3951 10.8051 12.9584C10.8141 12.9469 10.8228 12.9355 10.8313 12.9237L14.6977 7.52289C14.9489 7.17209 14.868 6.68396 14.5172 6.43295C14.1664 6.18179 13.6783 6.26251 13.4273 6.61331L9.57642 11.9923C9.47128 12.1143 9.33945 12.1405 9.2688 12.1452C9.19617 12.1503 9.05502 12.1408 8.93402 12.0256L6.44104 9.63181C6.12976 9.33289 5.63522 9.34296 5.33646 9.65424C5.03769 9.96536 5.04761 10.4601 5.35889 10.7588L7.85431 13.1549C8.22815 13.5107 8.72696 13.7086 9.24026 13.7086C9.28436 13.7086 9.32846 13.7073 9.37271 13.7042Z" fill="white"/>
				</svg>
				Implementation
            </div>
        </div>
    </a>  -->

  <div
    *isPermitted="{ id: 'EMAIL_NOTIFICATION', action: 'read' }"
    tamsyMargin
    marginB="2"
    class="item"
    routerLink="admin/email-notification"
    routerLinkActive="active"
  >
    <div class="middle aligned center">
      <div class="header">
        <i class="envelope icon"></i>
        Email Notification
      </div>
    </div>
  </div>
  <div
    tamsyMargin
    marginB="2"
    class="item"
    routerLink="admin/setting"
    routerLinkActive="active"
  >
    <div class="middle aligned center">
      <div class="header">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1425:8013)">
            <path
              d="M0.78125 4.14062H9.88281C10.3143 4.14062 10.6641 3.79086 10.6641 3.35938C10.6641 2.92789 10.3143 2.57812 9.88281 2.57812H0.78125C0.349766 2.57812 0 2.92789 0 3.35938C0 3.79086 0.349766 4.14062 0.78125 4.14062Z"
              fill="white"
            />
            <path
              d="M14.5703 6.67969C15.8627 6.67969 16.9141 5.62828 16.9141 4.33594V4.14062H19.2188C19.6502 4.14062 20 3.79086 20 3.35938C20 2.92789 19.6502 2.57812 19.2188 2.57812H16.9141V2.34375C16.9141 1.05141 15.8627 0 14.5703 0C13.278 0 12.2266 1.05141 12.2266 2.34375V4.33594C12.2266 5.62828 13.278 6.67969 14.5703 6.67969ZM13.7891 2.34375C13.7891 1.91297 14.1395 1.5625 14.5703 1.5625C15.0011 1.5625 15.3516 1.91297 15.3516 2.34375V4.33594C15.3516 4.76672 15.0011 5.11719 14.5703 5.11719C14.1395 5.11719 13.7891 4.76672 13.7891 4.33594V2.34375Z"
              fill="white"
            />
            <path
              d="M9.88102 15.8984H0.78125C0.349766 15.8984 0 16.2482 0 16.6797C0 17.1112 0.349766 17.4609 0.78125 17.4609H9.88102C10.3125 17.4609 10.6623 17.1112 10.6623 16.6797C10.6623 16.2482 10.3125 15.8984 9.88102 15.8984Z"
              fill="white"
            />
            <path
              d="M0.78125 10.7766H3.00781C3.4393 10.7766 3.78906 10.4268 3.78906 9.99536C3.78906 9.56388 3.4393 9.21411 3.00781 9.21411H0.78125C0.349766 9.21411 0 9.56388 0 9.99536C0 10.4268 0.349766 10.7766 0.78125 10.7766Z"
              fill="white"
            />
            <path
              d="M19.2188 9.21398H10.0391V8.94531C10.0391 7.65297 8.98766 6.60156 7.69531 6.60156C6.40297 6.60156 5.35156 7.65297 5.35156 8.94531V10.9766C5.35156 12.2689 6.40297 13.3203 7.69531 13.3203C8.98766 13.3203 10.0391 12.2689 10.0391 10.9766V10.7765H19.2188C19.6502 10.7765 20 10.4267 20 9.99523C20 9.56379 19.6502 9.21398 19.2188 9.21398ZM8.47656 10.9766C8.47656 11.4073 8.12609 11.7578 7.69531 11.7578C7.26453 11.7578 6.91406 11.4073 6.91406 10.9766V8.94531C6.91406 8.51453 7.26453 8.16406 7.69531 8.16406C8.12609 8.16406 8.47656 8.51453 8.47656 8.94531V10.9766Z"
              fill="white"
            />
            <path
              d="M19.2191 15.8984H16.9127V15.6641C16.9127 14.3717 15.8613 13.3203 14.5689 13.3203C13.2766 13.3203 12.2252 14.3717 12.2252 15.6641V17.6562C12.2252 18.9486 13.2766 20 14.5689 20C15.8613 20 16.9127 18.9486 16.9127 17.6562V17.4609H19.2191C19.6506 17.4609 20.0004 17.1112 20.0004 16.6797C20.0004 16.2482 19.6506 15.8984 19.2191 15.8984ZM15.3502 17.6562C15.3502 18.087 14.9997 18.4375 14.5689 18.4375C14.1381 18.4375 13.7877 18.087 13.7877 17.6562V15.6641C13.7877 15.2333 14.1381 14.8828 14.5689 14.8828C14.9997 14.8828 15.3502 15.2333 15.3502 15.6641V17.6562Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1425:8013">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Settings
      </div>
    </div>
  </div>
</div>
